import styled from 'styled-components';
import breakpoints from '../breakpoints';
import ChevronDown from '../images/chevron-down.svg';

const FormContainer = styled.form`
  display: block;
  font-family: inherit;
  font-size: 1rem;
  box-sizing: border-box;
  width: 100%;

  label {
    display: flex;
    flex-direction: column;

    span {
      display: block;
      flex: 1;
      font-size: 1rem;
      font-weight: 500;
      letter-spacing: normal;
    }
  }

  button {
    width: ${({ theme }) => theme?.form?.button?.width};
    margin-top: ${({ theme }) => theme?.form?.button?.marginTop};
  }

  select,
  input {
    border: 1px solid rgb(204, 204, 204);
    border-radius: ${({ theme }) => theme?.input?.borderRadius ?? '0.25rem'};
    background: #fff none repeat scroll 0 0;
    padding: 0.5rem;
    font-size: 1rem;
    flex-direction: column;
    flex: 1 1 0;
    box-sizing: border-box;
    width: 100%;
    margin-top: 0.375rem;
  }

  input[type='file'] {
    background: transparent;
    border: none;
    padding: 0;
    display: flex;
  }

  input[type='date'],
  select {
    height: 2.65rem;
  }

  select {
    background-image: url(${ChevronDown});
    background-repeat: no-repeat;
    background-size: 0.65em auto, 100%;
    background-position: calc(100% - 0.75rem) center;
    appearance: none;
  }

  textarea {
    min-height: 8rem;
    resize: vertical;
  }

  .asterisk {
    font-size: 16px;
    color: rgb(204, 71, 73);
    display: contents;
  }

  .hint {
    font-size: 0.8125rem;
    font-weight: inherit;
    color: inherit;
    display: block;
  }

  .styled-label {
    display: flex;
    flex-direction: column;
    font-size: 0.8125rem;
    font-weight: 500;
    letter-spacing: normal;
    color: #33363a;
    text-transform: initial;
  }

  .forgot-password-link {
    display: block;
    font-weight: 500;
    text-decoration: underline;
    margin-top: 1rem;

    @media screen and (max-width: ${breakpoints.md}) {
      padding: 0;
    }
  }

  .forgot-password-link:hover {
    text-decoration: none;
  }

  .hidden {
    display: none;
  }
`;

export default FormContainer;
